/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { isStrEmptyOrNull, isObjEmptyOrNull } from '../../common/UtilityFunctions';
import DefaultModal from './DefaultModal';
import { Button, Divider } from '@mui/material';
import Styles from '../../css/ServicerEscrowAnalysis.module.css';
import { useApplyAEAContext } from '../../contexts/ApplyAEAContext';
import { useEscrowAnalysisCalculationContext } from '../../contexts/CalculateEscrowAnalysisContext';
import { useCallback } from 'react';

const successOrErrorApplyingAEAModal = () => {
  const {
    applyAEAResultRetrieved,
    errorApplyingAEA,
    applyingAEA,
    applyAEAResp,
    setApplyAEAClicked,
    setApplyAEAResultRetrieved,
  } = useApplyAEAContext();

  const {
    escrowAnalysisCalculation,
    setEscrowAnalysisCalculated,
    setShortageMonths,
    setEscrowCushionMonths,
    setEffectiveDate,
  } = useEscrowAnalysisCalculationContext();

  const handleUnderstood = useCallback(() => {
    setApplyAEAClicked(false);
    setApplyAEAResultRetrieved(false);
    setEscrowAnalysisCalculated(false);
    setEffectiveDate(null);
    setEscrowCushionMonths(0);
    setShortageMonths(12);
  }, []);

  const refundTransactionAmountPresent =
    applyAEAResultRetrieved &&
    !isObjEmptyOrNull(applyAEAResp) &&
    'refundTransaction' in applyAEAResp &&
    'amount' in applyAEAResp.refundTransaction.data;

  const successApplyingAEA = !isObjEmptyOrNull(applyAEAResp) && isStrEmptyOrNull(errorApplyingAEA);

  return (
    applyAEAResultRetrieved && (
      <DefaultModal
        open={applyAEAResultRetrieved}
        title={
          <div className={Styles.modaltitle}>
            {successApplyingAEA ? 'Successfully applied AEA' : 'Error applying AEA'}
          </div>
        }
        content={
          <div className={Styles.modalcontainer}>
            {!successApplyingAEA ? (
              <div className={Styles.errortext}>{errorApplyingAEA}</div>
            ) : (
              <>
                <div className={Styles.row}>
                  <div>
                    <p className={Styles.modallabel}>New Escrow Payment:</p>
                    <p className={Styles.modallabel}>New Monthly Payment:</p>
                    <p className={Styles.modallabel}>Payment Change:</p>
                    {refundTransactionAmountPresent && <p className={Styles.modallabel}>Refund:</p>}
                  </div>

                  <div>
                    <p>${parseFloat(escrowAnalysisCalculation.newMonthlyImpound).toFixed(2)}</p>
                    <p>${parseFloat(escrowAnalysisCalculation.newMonthlyPayment).toFixed(2)}</p>
                    <p>${parseFloat(escrowAnalysisCalculation.pitiDiff).toFixed(2)}</p>
                    {refundTransactionAmountPresent && (
                      <p>${parseFloat(applyAEAResp.refundTransaction.data.amount).toFixed(2)}</p>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        }
        footer={
          <div className={Styles.buttonrow}>
            <Button fullWidth variant='contained' onClick={handleUnderstood} className={Styles.primbutton}>
              {!successApplyingAEA ? 'I Understand' : 'OK'}
            </Button>
          </div>
        }
      ></DefaultModal>
    )
  );
};

export default successOrErrorApplyingAEAModal;
